import script from "./LTECard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LTECard.vue?vue&type=script&setup=true&lang=ts"

import "./LTECard.vue?vue&type=style&index=0&id=3d085589&lang=css"

const __exports__ = script;

export default __exports__